module.exports = __webpack_public_path__ + "static/uhf-logo-4b851eedab83a1ad3b5e25758c735601.jpg";